/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Modals\ModalGroup\ModalGroup.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday July 20th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 21st August 2023 02:37:05
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Fragment, MouseEventHandler, useEffect, useState } from "react";
import MyModal from "Content/Modals/MyModal";
import {Form, Button, Col, InputGroup} from "react-bootstrap";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Modals/ModalPack/ModalPack.module.css";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import VisualService from "Services/Visuals/VisualService";

type ModalProps = {
    show: boolean;
    onClose: MouseEventHandler<HTMLDivElement>;
    closeModal: MouseEventHandler;
    title: string,
    collections: {id: string, Name: string}[],
};

function ModalVisual(props: ModalProps) {
    const [url, setUrl] = useState<string | undefined>();
    const [file, setFile] = useState<File | undefined>();
    const [isSendable, setIsSendable] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [collectionSelected, setCollectionSelected] = useState<{id: string, Name: string}>();

    const setModalConfig = (isSendable=false, isOkay=false) => {
        setIsSendable(isSendable);
        setIsOkay(isOkay);
    }

    const HandleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!collectionSelected)
            return;
        setSpinner(true);
        try {
            var myUrl: URL | undefined = undefined;
            if (url)
                myUrl = new URL(url!);
            let visual = await VisualService.createVisual({name: `Mobybuy${Date.now()}`, collectionID: collectionSelected.id, visual: file, url: myUrl});
            if (visual) {
                setUrl(undefined);
                setFile(undefined);
                setModalConfig(false, true);
            } else {
                setModalConfig(false, false);
            }
        } catch (e: any) {
            setUrl(undefined);
            setFile(undefined);
            setModalConfig(false, false);
        }
        setOpenModal(true);
        setSpinner(false);
    };

    useEffect(() => {
        if (url) {
            try {
                new URL(url);
                setIsSendable(true);
            } catch {
                setIsSendable(false);
            }
        } else
            setIsSendable(false);
    }, [url]);

    useEffect(() => {
        if (file) {
            setIsSendable(true);
        } else
            setIsSendable(false);
    }, [file]);

    function setFromFile(e: any) {
        setFile(e.target.files[0]);
    };

    return(
        <Fragment>
            <MyModal closeModal={props.closeModal} show={props.show} addCloseCross={true} onClose={props.onClose} footer={(() => { return (<></>); })()} title={props.title} className={Styles.modal}>
                <Form className={`${Styles.formHolder}`} onSubmit={HandleSubmit}>
                    <Form.Group className={`${Styles.formfield}`} >
                        <Col>
                        {file == undefined ?
                        <Fragment>
                            <Form.Label>
                                {translator.decode("visuals.modal.url")}
                            </Form.Label>
                            <Form.Control type="text" value={url ?? ""} onChange={(e) => e.target.value && e.target.value.length > 0 ? setUrl(e.target.value) : setUrl(undefined)} />
                        </Fragment>
                        : null}
                        {url == undefined ?
                        <Fragment>
                            <Form.Label>
                                {translator.decode("visuals.modal.file")}
                            </Form.Label>
                            <InputGroup>
                                <Form.Control type="file"  placeholder={translator.decode("visuals.modal.pickfile")} onChange={setFromFile} />
                            </InputGroup>
                        </Fragment>
                        : null }
                        <Fragment>
                            <Form.Label>
                                {translator.decode("collections.modal.name")}
                            </Form.Label>
                            <InputGroup>
                                <Form.Select value={collectionSelected?.id ?? ""}
                                    onChange={(e) => {
                                        const selectedId = e.target.value;
                                        const selected = props.collections.find(c => c.id === selectedId);
                                        setCollectionSelected(selected);
                                    }}>
                                    <option value="" disabled>{translator.decode("visuals.modal.pickcollection")}</option>
                                        {props.collections.map(collection => (
                                            <option key={collection.id} value={collection.id}>
                                                {collection.Name}
                                            </option>
                                    ))}
                                </Form.Select>
                            </InputGroup>
                        </Fragment>
                        </Col>
                    </Form.Group>
                    <Button disabled={!isSendable || !collectionSelected} className="mb-3" type="submit">{translator.decode("dynamic.create")}</Button>
                </Form>
                {
                    spinner ?
                        <div className={`${Styles.spinnerHolder}`}>
                            <LoadingScreen />
                        </div>
                        :null
                }
            </MyModal>
            <ModalConfirmation show={openModal} onClose={(e) => { setOpenModal(false); props.closeModal(e) }} closeModal={(e) => { setOpenModal(false); props.closeModal(e) }} isOkay={isOkay} />
        </Fragment>
    )
}

export default ModalVisual;
